<template>
  <div class="relative" @mouseenter="showCarousel = $viewport.lg">
    <base-picture
      :alt="items[0]?.alt || `${name} - 1`"
      class="w-full"
      data-test-id="product-card-pic"
      :height="mediaSize.height"
      :lazy
      :props-img="{ class: 'w-a', fetchpriority }"
      :src="getImageTransformations(items[0]?.src, { ...mediaSize, ...mediaTransformations }) || defaultImageUrl"
      :width="mediaSize.width"
    />
    <slot v-if="items.length === 1 || !(showSecondaryMedia || showCarousel)" name="link" />
    <transition v-if="items[1]?.src" name="fade">
      <template v-if="showSecondaryMedia || showCarousel">
        <lazy-product-card-carousel
          v-if="$feature.enableProductCardGalleryCarousel"
          :items
          :lazy
          :name
          style="position: absolute; inset: 0"
        >
          <template #link>
            <slot name="link" />
          </template>
        </lazy-product-card-carousel>
        <component
          :is="items[1].type === 'image' ? BasePicture : BaseVideo"
          v-else
          :alt="items[1].alt || `${name} - 2`"
          autoplay
          class="absolute-0 full"
          :class="{ 'bg-black': items[1].type !== 'image' }"
          data-test-id="product-card-pic-hover"
          fit="contain"
          :height="mediaSize.height"
          :lazy
          loop
          :src="items[1].type === 'image'
            ? getImageTransformations(items[1].src, { ...mediaSize, ...mediaTransformations })
            : items[1].src"
          :width="mediaSize.width"
        />
      </template>
    </transition>
    <slot name="badge" />
  </div>
</template>

<script lang="ts" setup>
import type { ProductGalleryExtended } from '#root/api/clients/product/data-contracts'
import type { ImgHTMLAttributes } from '#types/components/base/picture'
import { BasePicture, BaseVideo } from '#components'

export type Props = {
  items?: ProductGalleryExtended
  lazy?: boolean
  name: string
  productId?: string
  showSecondaryMedia?: boolean
}

const { items = [] } = defineProps<Props>()

const { card: { mediaSize, mediaTransformations }, defaultImageUrl } = useAppConfig().components.product
const { fetchpriority } = useAttrs() as ImgHTMLAttributes

const showCarousel = ref(false)
</script>
